/*import './App.css';*/
/*import Landingpage from './Component/Landingpage/Landingpage';*/
import Backtotop from './Global/Backtotop';
import { Route, Router,BrowserRouter } from 'react-router-dom';
import { Loginwithmobilenumber } from './Component/Login/Loginwithmobilenumber';
import { useContext, useState,Suspense, useEffect,lazy } from 'react';
import { UserContext, UserContextProvider } from './Component/User/UserContext';
/*import { Authentication } from './Component/Login/Authentication';
import LandingIndex from './LandingIndex';*/
import { Pagenotfoundlandingpage } from './Global/Pagenotfoundlandingpage';
import LoaderSpinner from "./Global/LoaderSpinner";
import { Loaderwithlogo } from './Global/Loaderwithlogo';
import  BannerDisplay  from './Component/Banner/Banner';
const Landingpage = lazy(() => import('./Component/Landingpage/Landingpage'));
const Authentication = lazy(() => import('./Component/Login/Authentication'));
const LandingIndex = lazy(() => import('./LandingIndex'));
export const App=()=> {
      const {Userinfo}=useContext(UserContext)
      const [screenWidth, setScreenWidth] = useState(window.innerWidth);
	useEffect(() => {
		// Update the screenWidth state when the window is resized
		const handleResize = () => {
		  setScreenWidth(window.innerWidth);
		};
	
		window.addEventListener('resize', handleResize);
	
		// Clean up the event listener when the component unmounts
		return () => {
		  window.removeEventListener('resize', handleResize);
		};
	  }, []); // Empty dependency array to run this effect only once
       return (
       <>
	   <Suspense fallback={ 
				<Loaderwithlogo></Loaderwithlogo>
		   } >
       {
	   (Userinfo.Loggedas ==='') ? 
	   <BrowserRouter>
	   {<Authentication screenWidth={screenWidth}  ></Authentication>}
	   </BrowserRouter> : 
	    <Landingpage screenWidth={screenWidth}> </Landingpage> 
		/*<BannerDisplay></BannerDisplay>*/ 
	   }
	
	   </Suspense>
       <Backtotop></Backtotop>
       </>
       );
}

export default App;
